<template>
  <v-container>
    <v-data-table :headers="headers" :items="cotizaciones" item-key="id"
      :sort-by="[{ key: 'created_at', order: 'desc' }]">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Gestión de Cotizaciones</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn color="secondary" variant="flat" class="mr-2" prepend-icon="mdi-presentation"
            @click="abrirCotizador">
            Cotizador
          </v-btn>
          <v-btn color="primary" variant="flat" @click="openDialogForNew">
            Nueva Cotización
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:[`item.id`]="{ item }">
        {{ formatNumero(item.id) }}
      </template>

      <template v-slot:[`item.created_at`]="{ item }">
        {{ moment(item.created_at).format("DD-MM-YYYY hh:mm:ss A") }}
      </template>

      <template v-slot:[`item.total`]="{ item }">
        <v-chip color="primary" dark>
          S/ {{ Number(item.total).toFixed(2) }}
        </v-chip>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip text="Editar" location="top">
          <template v-slot:activator="{ props }">
            <v-icon class="me-2" size="small" v-bind="props" @click="editItem(item)">
              mdi-pencil
            </v-icon>
          </template>
        </v-tooltip>


        <v-tooltip text="Imprimir PDF" location="top">
          <template v-slot:activator="{ props }">
            <v-icon class="me-2" size="small" v-bind="props" @click="printItem(item)">
              mdi-printer
            </v-icon>
          </template>
        </v-tooltip>

        <v-tooltip text="Descargar" location="top">
          <template v-slot:activator="{ props }">
            <v-icon class="me-2" size="small" v-bind="props" @click="downloadItem(item)">
              mdi-download
            </v-icon>
          </template>
        </v-tooltip>

        <v-tooltip text="Enviar a WhatsApp" location="top">
          <template v-slot:activator="{ props }">
            <v-icon class="me-2" size="small" v-bind="props" @click="sendWhatsapp(item)">
              mdi-whatsapp
            </v-icon>
          </template>
        </v-tooltip>

        <v-tooltip text="Eliminar" location="top">
          <template v-slot:activator="{ props }">
            <v-icon size="small" v-bind="props" @click="confirmDelete(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-tooltip>
      </template>

      <template v-slot:no-data>
        <v-btn color="primary" @click="fetchCotizaciones">Resetear</v-btn>
      </template>
    </v-data-table>

    <!-- Diálogo para crear/editar -->
    <CotizacionDialog :dialog="dialog" :editedItem="editedItem" :formTitle="formTitle" @update:dialog="dialog = $event"
      @close="closeDialog" @save="saveDialog" />

    <!-- Diálogo de confirmación -->
    <v-dialog v-model="dialogDelete" width="auto" persistent>
      <v-card max-width="400" prepend-icon="mdi-delete" title="Eliminar Cotización"
        text="¿Está seguro de eliminar esta cotización?">
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="closeDelete">Cancelar</v-btn>
          <v-btn color="red-darken-1" text @click="deleteItemConfirm">Eliminar</v-btn>
        </template>
      </v-card>
    </v-dialog>

    <!-- Diálogo fullscreen para mostrar el PDF -->
    <v-dialog v-model="showPdfDialog" fullscreen persistent transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon @click="showPdfDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Vista previa de Cotización</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text class="pa-0" style="height: 100%;">
          <iframe v-if="pdfUrl" :src="pdfUrl" style="width: 100%; height: calc(100vh - 64px); border: none;"></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Diálogo fullscreen para el Cotizador (presentación interactiva) -->
    <v-dialog v-model="cotizadorDialog" fullscreen :scrim="false" transition="dialog-bottom-transition">
      <div ref="cotizadorContenedor" class="cotizador-wrap">
        <v-toolbar dark color="primary" density="compact">
          <v-toolbar-title>Cotizador</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon title="Pantalla completa" @click="pantallaCompletaCotizador">
            <v-icon>mdi-fullscreen</v-icon>
          </v-btn>
          <v-btn icon title="Cerrar" @click="cerrarCotizador">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <iframe
          v-if="cotizadorUrl"
          ref="cotizadorFrame"
          :src="cotizadorUrl"
          class="cotizador-frame"
          allow="fullscreen"
          allowfullscreen
        ></iframe>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import CotizacionDialog from '@/components/cotizacion/CotizacionDialog.vue';
import axios from 'axios';

export default {
  components: { CotizacionDialog },
  data() {
    return {
      moment,
      dialog: false,
      dialogDelete: false,
      showPdfDialog: false,
      pdfUrl: '',
      cotizadorDialog: false,
      cotizadorUrl: '',
      headers: [
        { title: 'Número', value: 'id' },
        { title: 'Fecha Emisión', value: 'created_at' },
        { title: 'DNI', value: 'numero_documento' },
        { title: 'Celular', value: 'numero_celular_cliente' },
        { title: 'Cliente', value: 'nombre_cliente' },
        { title: 'Total', value: 'total' },
        { title: 'Acciones', value: 'actions', sortable: false },
      ],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {
        dni: '',
        nombres: '',
        numero_celular_cliente: '',
        condiciones_pago: '',
        notas: '',
        items: [],
        total: 0,
      },
    };
  },
  computed: {
    ...mapGetters('cotizacion', ['cotizaciones']),
    formTitle() {
      return this.editedIndex === -1 ? 'Nueva Cotización' : 'Editar Cotización';
    },
  },
  created() {
    this.fetchCotizaciones();
  },
  methods: {
    ...mapActions('cotizacion', [
      'fetchCotizaciones',
      'guardarCotizacion',
      'updateCotizacion',
      'deleteCotizacion',
      'getCotizacionById',
    ]),

    async abrirCotizador() {
      const base = (process.env.VUE_APP_API_URL || 'http://localhost').replace(/\/$/, '');
      this.cotizadorUrl = `${base}/cotizador/index.html`;
      this.cotizadorDialog = true;
      // Intentar pantalla completa real del navegador (el click es el gesto del usuario)
      await this.$nextTick();
      this.pantallaCompletaCotizador();
    },

    pantallaCompletaCotizador() {
      const el = this.$refs.cotizadorContenedor;
      if (el && el.requestFullscreen) {
        el.requestFullscreen().catch(() => {});
      }
    },

    cerrarCotizador() {
      if (document.fullscreenElement) {
        document.exitFullscreen().catch(() => {});
      }
      this.cotizadorDialog = false;
      this.cotizadorUrl = '';
    },

    openDialogForNew() {
      this.editedItem = null;
      this.editedIndex = -1;
      this.dialog = true;
    },

    async editItem(item) {
      try {
        const cotizacion = await this.getCotizacionById(item.id);
        this.editedItem = cotizacion;
        this.editedIndex = this.cotizaciones.findIndex(c => c.id === item.id);
        this.dialog = true;
      } catch (error) {
        console.error('Error obteniendo cotización:', error);
      }
    },


    printItem(item) {
      this.pdfUrl = `${process.env.VUE_APP_API_URL}/api/cotizacion/${item.id}/pdf`;
      this.showPdfDialog = true;
    },

    async downloadItem(item) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}/api/cotizacion/${item.id}/pdf`,
          { responseType: 'blob' }
        );

        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', `Cotizacion-${item.id}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error('Error descargando PDF:', error);
      }
    },

    async sendWhatsapp(item) {
      try {
        const phone = item.numero_celular_cliente || "";
        const message = 'Hola Somos MARC Escuela de Manejo aqui esta la cotizacion';
        window.open(`https://wa.me/+51${phone}?text=${encodeURIComponent(message)}`, '_blank');
      } catch (error) {
        console.error('Error enviando WhatsApp:', error);
      }
    },

    confirmDelete(item) {
      this.editedIndex = this.cotizaciones.findIndex(c => c.id === item.id);
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.deleteCotizacion(this.editedItem.id)
        .then(() => {
          this.fetchCotizaciones();
          this.closeDelete();
        })
        .catch(error => {
          console.error('Error eliminando cotización:', error);
        });
    },

    closeDialog() {
      this.dialog = false;
    },

    closeDelete() {
      this.dialogDelete = false;
    },

    saveDialog(item) {
      const action = this.editedIndex === -1 ? this.guardarCotizacion : this.updateCotizacion;

      action(item)
        .then(() => {
          this.fetchCotizaciones();
          this.closeDialog();
        })
        .catch(error => {
          console.error('Error guardando cotización:', error);
        });
    },

    formatNumero(id) {
      return `C-${String(id).padStart(6, '0')}`;
    },
  },
};
</script>

<style scoped>
.cotizador-wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #000;
}

.cotizador-frame {
  flex: 1 1 auto;
  width: 100%;
  border: none;
}
</style>
